import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingAgenciesUseCasePage } from "../components/marketing/MarketingAgenciesUseCasePage";

export const Route = createFileRoute("/use-cases/agencies")({
  head: () => marketingHead("/use-cases/agencies"),
  component: MarketingAgenciesUseCasePage,
});
